import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/baseCategory/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/baseCategory/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/baseCategory/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/baseCategory/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/baseCategory/delete/${id}`)
}

// 根据ID查询
export function queryById (id) {
  return request.get(`/business/baseCategory/${id}`)
}

// 修改状态
export function updateDisableById (data) {
  return request.post('/business/baseCategory/updateDisableById', data)
}